import { render, staticRenderFns } from "./CRUDCustomer.vue?vue&type=template&id=523ddac9&scoped=true"
import script from "./CRUDCustomer.vue?vue&type=script&lang=js"
export * from "./CRUDCustomer.vue?vue&type=script&lang=js"
import style0 from "./CRUDCustomer.vue?vue&type=style&index=0&id=523ddac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ddac9",
  null
  
)

export default component.exports